import { PersonFill } from 'react-bootstrap-icons'
import styles from './ProfileAvatar.module.css'

interface ProfileAvatarProps {
  profileImageUrl?: string
  userName?: string
  size?: number
  className?: string
  initials?: boolean
}

const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return ''
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase()
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
}

const ProfileAvatar = ({
  profileImageUrl,
  userName,
  size = 28,
  className = '',
  initials = false
}: ProfileAvatarProps) => {
  const altText = userName
    ? `${userName}'s profile picture`
    : profileImageUrl
      ? 'Profile picture'
      : 'Default profile icon'

  if (profileImageUrl) {
    return (
      <img
        src={profileImageUrl}
        alt={altText}
        className={`${styles.avatar} ${className}`}
        style={{ width: size, height: size }}
      />
    )
  }

  const initialsText = initials && userName ? getInitials(userName) : ''

  return (
    <span
      className={`${styles.placeholder} ${className}`.trim()}
      style={{ width: size, height: size }}
      role="img"
      aria-label={altText}
    >
      {initialsText ? (
        <span className={styles.initials} style={{ fontSize: Math.round(size * 0.4) }}>
          {initialsText}
        </span>
      ) : (
        <PersonFill size={Math.round(size * 0.6)} className={styles.placeholderIcon} />
      )}
    </span>
  )
}

export default ProfileAvatar
